import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { ILoading } from 'models/Loading'
import { IRoster } from 'models/Roster'
import { IBusinessUpshifter, IBusinessUpshiftersSortingState } from 'models/BusinessUpshifter'

export const BusinessUpshiftersFetching = action('BusinessUpshiftersFetching', payload<boolean>())

export const GetBusinessUpshifters = action(
  'GetBusinessUpshifters',
  payload<IPayload<IBusinessUpshifter[]>>()
)

export const GetBusinessUpshiftersErrors = action('GetBusinessUpshiftersErrors', payload<IError>())

export const DeleteFromRoster = action('DeleteFromRoster', payload<number>())

export const SetDeleteFromRosterLoading = action('SetDeleteFromRosterLoading', payload<ILoading>())

export const AddToMultipleRosters = action(
  'AddToMultipleRosters',
  payload<{ upshifterId: number; rosters: IRoster[] }>()
)

export const SetBusinessUpshiftersSorting = action(
  'SetBusinessUpshiftersSorting',
  payload<IBusinessUpshiftersSortingState>()
)

export const ResetBusinessUpshiftersSorting = action('ResetBusinessUpshiftersSorting')
